import React from 'react';
import PropTypes from 'prop-types';
import { Container, Alert } from 'react-bootstrap';


class MapInstruction extends React.Component {
  static defaultProps = {
    title: 'Pomoc:',
    variant: 'light',        
    bordered: true,        
    dismissible: false,      
    onClose: undefined,
    items: [
      'Menu edycji kształtu warstwy znajduje się w prawym górnym rogu mapy (przyciski).',
      'Aby dodać nowy kształt warstwy wybierz pierwszą opcję z menu i narysuj kształt na mapie. ',
      'Aby edytować istniejący kształt wybierz drugą opcję z menu i przeciągnij wierzchołki kształtu według preferencji. ', 
      'Aby zmienić położenie istniejącego kształtu na mapie wybierz trzecią opcję z menu i przeciągnij kształt na mapie.',
      'Aby usunąć kształ wybierz opcję czwartą i kliknij na kształt, który chcesz wymazać',
      'Aby obrócić istnijący kształt na mapie wybierz piątą opcję z menu i przeciągnij myszką w kierunku obrotu.',
      'Pamiętaj! Aby zapisać zmiany w warstwie, musisz kliknąć przycisk "Zapisz" pod formularzem edycji warstwy.'
    ],
    containerProps: {},
    className: ''
  };

  renderList() {
    const { items, children } = this.props;
    if (children) return <div>{children}</div>;

    return (
      <ul className="mb-0">
        {items.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>
    );
  }

  render() {
    const {
      title,
      variant,
      bordered,
      dismissible,
      onClose,
      containerProps,
      className
    } = this.props;

    const alertClasses = [bordered ? 'border' : '', className]
      .filter(Boolean)
      .join(' ');

    return (
      <Container {...containerProps}>
        <Alert
          variant={variant}
          className={alertClasses}
          dismissible={dismissible}
          onClose={onClose}
        >
          <div className="mb-2">
            <strong>{title}</strong>
          </div>
          {this.renderList()}
        </Alert>
      </Container>
    );
  }
}

MapInstruction.propTypes = {
  /** Tekst nagłówka (np. "Pomoc:") */
  title: PropTypes.string,
  /** Wariant react-bootstrap Alert (np. 'light', 'secondary', 'info') */
  variant: PropTypes.string,
  /** Czy dodać cienką ramkę wokół alertu */
  bordered: PropTypes.bool,
  /** Czy alert ma być zamykany krzyżykiem */
  dismissible: PropTypes.bool,
  /** Handler zamknięcia (wymagany, gdy dismissible=true) */
  onClose: PropTypes.func,
  /** Lista pozycji; jeżeli podasz children, items będzie zignorowane */
  items: PropTypes.arrayOf(PropTypes.string),
  /** Props przekazywane do <Container /> (np. { fluid: true, className: 'my-3' }) */
  containerProps: PropTypes.object,
  /** Dodatkowe klasy CSS na <Alert /> */
  className: PropTypes.string,
  /** Własna treść/JSX – nadpisuje items */
  children: PropTypes.node
};

export default MapInstruction;